import { NotificationCountBadge } from "@dash/nav";
import { useTheme } from "@emotion/react";

import { SignalDoc, SignalType } from "@megaron/docs-contracts";

import { navBadgeState } from "./navBadgeState";

type Props = {
  signals: SignalDoc[];
  badgeSignalTypes: readonly SignalType[];
  color: string;
};

export const SignalsBadge: React.FC<Props> = ({ signals, badgeSignalTypes, color }) => {
  const theme = useTheme();
  const { count, hasUnread } = navBadgeState(signals, badgeSignalTypes);

  if (count === 0) return null;

  return (
    <span
      css={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 0,
        pointerEvents: "none",
      }}
    >
      <NotificationCountBadge
        count={count}
        backgroundColor={hasUnread ? color : theme.colors.secondaryText}
        color="white"
        withShadow={false}
      />
    </span>
  );
};
